import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { FaSearch } from "react-icons/fa";
import { MdOutlineReportGmailerrorred } from "react-icons/md";

const NoResults = ({
  title = "No results found",
  description,
  search,
  iconSize = 32,
  iconOpacity = 0.5,
  children,
}) => {
  return (
    <VuiBox
      py={6}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <VuiBox mb={0} opacity={iconOpacity}>
        <MdOutlineReportGmailerrorred size={32} />
      </VuiBox>

      <VuiTypography variant="body" mb={1}>
        {title}
      </VuiTypography>

      {(description || search) && (
        <VuiTypography variant="body2">
          {description || (
            <>
              No results match <strong>"{search}"</strong>
            </>
          )}
        </VuiTypography>
      )}

      {children && <VuiBox mt={2}>{children}</VuiBox>}
    </VuiBox>
  );
};

export default NoResults;
